import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  userProfile(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/user/details', {withCredentials: true});
  }

  getApplicantDetails(uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/database/${uuid}/show`, {withCredentials: true});
  }

  verifyApplication(uuid): Observable<any> {
    return this.http
    .patch<any>(environment.apiUrl + `api/v1/database/${uuid}/verify`, '',{withCredentials: true});
  }

  transmitApplication(uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `api/v1/database/${uuid}/transmit`, '',{withCredentials: true});
  }
}
